// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
/**
 * WgptService provides an API to Chat GPT
 */
export const WgptService = {
    CreateReviewCompletion(fn, req) {
        return fn(`/wgpt/v1/review/completion`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateEmail(fn, req) {
        return fn(`/wgpt/v1/emails`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateSubjects(fn, req) {
        return fn(`/wgpt/v1/subjects`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    RefineEmail(fn, req) {
        return fn(`/wgpt/v1/emails:refine`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    RefineSubject(fn, req) {
        return fn(`/wgpt/v1/subjects:refine`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListRefinements(fn, req) {
        return fn(`/wgpt/v1/refinements?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    RefineMessage(fn, req) {
        return fn(`/wgpt/v1/messages:refine`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
